<div class="bg">
    <section class="container-wrapper">
        <div class="logo">
            <img src="assets/logo-white.png" class="brand img-fluid bg-transparent" alt="">
        </div>
        <router-outlet></router-outlet>

    </section>
</div>
